<template>
  <div>
    <navbar/>
    <pricing/>
  </div>
</template>

<script>

import pricing from '@/components/pricing.vue';
import navbar from '@/components/navbar.vue';

export default {
  name: 'DownloadView',
  components: {
    navbar, 
    pricing, 
  }
}
</script>
